import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table, FormControl } from 'react-bootstrap';
import { getCourse, postApplicationConfiguration, getApplicationConfiguration,updateApplicationConfiguration } from "../../../api/applicationConfig";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ApplicationConfiguration() {
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [courses, setCourses] = useState([]);
    const [error, setError] = useState('');
    const [applicationConfiguration, setApplicationConfiguration] = useState([]);
    const [appNoPrefix, setAppNoPrefix] = useState("");
    const [appStartNo, setAppStartNo] = useState("");
    const [editingConfig, setEditingConfig] = useState(null);
    const [isActive, setIsActive] = useState(true);

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [courseResponse, applicationconfiguration] = await Promise.all([
                    getCourse(token),
                    getApplicationConfiguration(token)
                ]);

                setCourses(courseResponse.data);
                console.log("Courses:", courseResponse.data);
                setApplicationConfiguration(applicationconfiguration.data)
                console.log("applicationconfiguration", applicationconfiguration.data)


            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);


    const handleCoursechange = (event) => {
        setSelectedCourse(event.target.value);
    };

    const handleActiveChange = (e) => setIsActive(e.target.checked);

    const handleAppNoPrefixChange = (event) =>
        setAppNoPrefix(event.target.value);

    const handleAppStartNoChange = (event) => setAppStartNo(event.target.value);

    const handleSubmit = async () => {
        if (!appNoPrefix || !appStartNo) {
            toast.error("Please fill in all required fields!");
            return;
        }
        const token = localStorage.getItem("token");
        
        if (editingConfig) {
            const updatedConfig = {
                nepSubject: isActive,
                appNoPrefix,
                appStartNo: parseInt(appStartNo, 10),
            };
            try {
                await updateApplicationConfiguration(editingConfig.id, updatedConfig, token);
                toast.success("Data updated successfully!");
    
                const updatedData = await getApplicationConfiguration(token);
                setApplicationConfiguration(updatedData.data); 
                handleCancel(); 
            } catch (error) {
                toast.error("Error updating data. Please try again.");
            }
        } else {
            const applicationConfigurationDTO = {
                        courseId: parseInt(selectedCourse, 10),
                        nepSubject: isActive,
                        appNoPrefix,
                        appStartNo: parseInt(appStartNo, 10),
                    };
                    try {
                        await postApplicationConfiguration(applicationConfigurationDTO, token);
                        toast.success("Data submitted successfully!");
                          const updatedData = await  getApplicationConfiguration(token);
                          setApplicationConfiguration(updatedData.data)
                        handleCancel();
                    } catch (error) {
                        toast.error("Error submitting data. Please try again.");
                    }
                };
    };

    const handleEdit = (config) => {
        setEditingConfig(null);
        setEditingConfig(config);
        setSelectedCourse(config.course.id);
        setAppNoPrefix(config.appNoPrefix);
        setAppStartNo(config.appStartNo);
        setIsActive(config.nepSubject);
    };
    
    
    const handleCancel = () => {
        setSelectedCourse("");
        setAppNoPrefix("");
        setAppStartNo("");
        setIsActive(true);
        setEditingConfig(null);
    };
    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Application Configuration</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>
                                    <Row className="mb-3">

                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Course<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">

                                            <Form.Select type="text"
                                                placeholder="Enter Course"
                                                id="  Course"
                                                required
                                                value={selectedCourse}
                                                onChange={handleCoursechange}
                                            >
                                                <option value="">Select Course</option>
                                                {courses.map((course) => (
                                                    <option key={course.id} value={course.id}>
                                                        {course.courseName}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">

                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                        >
                                            Payment Mode<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">

                                            <Form.Select
                                                type="text"
                                                placeholder="Enter Payment Mode"
                                                id="Payment Mode"
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Application No. Perfix<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Enter Application No"
                                                id="Application No"
                                                value={appNoPrefix}
                                                onChange={handleAppNoPrefixChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Application Start No.<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Enter Application Start No"
                                                id="Application Start No"
                                                value={appStartNo}
                                                onChange={handleAppStartNoChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            NEP Subject
                                        </Form.Label>
                                        <Col className="mt-2">
                                            <Form.Check
                                                type="switch"
                                                id="CheckIfNEP"
                                                label="Check If NEP"
                                                checked={isActive}
                                                onChange={handleActiveChange}

                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col></Col>
                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3">
                                    <Button variant="primary" type="button"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Course</th>
                                            <th>Application No. Prefix</th>
                                            <th>Application Start No.</th>
                                            <th>NEP Subject</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {applicationConfiguration.map((config, index) => (
                                            <tr key={index}>
                                                <td>{config.course.courseName}</td>
                                                <td>{config.appNoPrefix}</td>
                                                <td>{config.appStartNo}</td>
                                                <td>{config.nepSubject ? "Yes" : "No"}</td>
                                                <td style={{ textAlign: "center" }}>
                                                        <Button variant="secondary" size="mb-3" type="button"
                                                             onClick={() => handleEdit(config)}  >
                                                            <i className="bi bi-pencil-fill me-2" />
                                                            Edit
                                                        </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Row>

                        </Form>
                    </Card.Body>
                </Card>
            </div>


        </>
    );
}

export default ApplicationConfiguration;